import { render, staticRenderFns } from "./JyDeptDaySchedule.vue?vue&type=template&id=153183f1"
import script from "./JyDeptDaySchedule.vue?vue&type=script&lang=js"
export * from "./JyDeptDaySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports